import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { LOAD_AGENTS_FOR_EXPERTS_SECTION } from 'apolloClient/queries/agents';
import { Agent, AgentsResponse } from 'apolloClient/types/Agents';
import { flattenStrapiBulkDataItems } from 'lib/flattenStrapiBulkDataItems';

export const FALLBACK_EXPERTS: Agent[] = [
  {
    id: 1,
    agentId: {
      id: 1,
      name: 'SEP NIAKAN',
      email: 'sep@blackbookproperties.com',
      job: 'Lic. Real Estate Broker',
      company: 'CondoBlackBook',
      picture: {
        original: 'https://cbbresources.s3.us-east-1.amazonaws.com/Sep-CBB.png',
      },
    },
    nickname: 'sepehr-niakan',
    description: 'Founder of condoblackbook.com',
    job: 'President / Lic. Real Estate Broker',
    company: 'CondoBlackBook',
    mediaLinks: [],
  },
];

export function useExperts(): {
  experts: Agent[];
  loading: boolean;
} {
  const { data, loading, error } = useQuery<{ agents: AgentsResponse }>(
    LOAD_AGENTS_FOR_EXPERTS_SECTION,
    {
      fetchPolicy: 'cache-first',
    }
  );

  const experts = useMemo(() => {
    if (data?.agents?.data) {
      const fetched = flattenStrapiBulkDataItems(data.agents.data);
      if (fetched?.length > 0) return fetched;
    }
    if (error) {
      console.error('[useExperts] Failed to fetch experts:', error.message);
    }
    if (!loading) return FALLBACK_EXPERTS;
    return [];
  }, [data, error, loading]);

  return {
    experts,
    loading: loading && experts.length === 0,
  };
}
